import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from '@angular/router';
import { Observable, } from 'rxjs';
import { WordpressService } from '../services/wordpress.service';
import { map } from 'rxjs/operators';

@Injectable()
export class JournalPostsResolveGuard implements Resolve<any> {
  constructor(
    private wp: WordpressService
  ) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.wp.getJournalPosts(1).pipe(map(res => {
      const totalPages = res && res.headers ? res.headers.get('x-wp-totalpages') : 1;
      const posts = res ? res.body : [];
      return {posts: posts, totalPage: totalPages};
    }));
  }
}
